import logger from '../../Utils/logger';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styles from "./Style.module.css";
import { bookingDetail, cancelBooking } from "../../APICalling/APICalling";
import BadgeConfirmed from "../../Assets/Images/badge-confirmed.svg";
import badgeCancel from "../../Assets/Images/badge-cancel.svg";
import badgeHold from "../../Assets/Images/badge-hold.svg";
import badgeNoShow from "../../Assets/Images/badge-noshow.svg";
import badgeCompleted from "../../Assets/Images/badge-completed.svg";
import badgeVoided from "../../Assets/Images/badge-voided.svg";
import BadgeUpdated from "../../Assets/Images/badge-updated.svg";
import BadgeCheckedIn from "../../Assets/Images/badge-checkedin.svg";
import TermsAndConditions from "../../Components/TermsAndConditions/TermsAndConditions";
import { BtnPrimary } from "../../Components/Buttons/BtnPrimary";
import { BtnSecondary } from "../../Components/Buttons/BtnSecondary";
import LoaderMain from "../../Components/Loader/LoaderMain";
import { BookingCancelConfirmationPopup } from "../../Components/Popup/BookingCancelConfirmationPopup/BookingCancelConfirmationPopup";
import { goToHome, splitDateTime } from "../../Utils/Helper";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useBookingSession } from "../../Context/BookingSession/BookingSessionContext";
import { Snakbar } from "../../Components/Snakbar/Snakbar";
import TimeDetail from "../../Components/TimeDetail/TimeDetail";
import { OutletCard } from "../../Components/OutletCard/OutletCard";
import ServiceDetails from "../../Components/ServiceDetails/ServiceDetails";
import PriceDetails from "../../Components/PriceDetails/PriceDetails";
import { transformCustomerData } from "../../Utils/transformCustomerData";
import { clearSessionStorage } from "../../Utils/SessionStorage";
import BookingStatus from "../../Components/BookingStatus/BookingStatus";
import { ReloadBookingPopup } from "../../Components/Popup/ReloadBookingPopup/ReloadBookingPopup";
import { ReschedulingExtendedPopup } from "../../Components/Popup/ReschedulingExtendedPopup/ReschedulingExtendedPopup";
import { useWebSettings } from "../../Context/WebSettings/WebSettingsContext";
import { useAppointment } from "../../Context/Appointment/AppointmentContext";
import { useCartDisplayTotal } from "../../Utils/Hooks/useCartDisplayTotal";
import { getErrorMessage } from "../../Utils/getErrorMessage";

const ManageAppointment = () => {
  const getSessionStorageValue = (key, defaultValue = null) => {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : defaultValue;
  };

  const { uuid } = useParams();
  const navigate = useNavigate();
  const { setRescheduleMaxLimit, setReschedulingTimeLimit: setSessionTimeLimitHours, uuid: sessionUuid, setUuid } = useBookingSession();
  const { rescheduleMaxLimit: webRescheduleMaxLimit, rescheduleTimeLimit: webRescheduleTimeLimit } = useWebSettings();
  const { membership } = useAppointment();

  const location = useLocation();
  const makeAnOtherAppointmentOnly = location.state?.makeAnOtherAppointmentOnly;

  const [mainLoading, setMainLoading] = useState(true);
  const [bookingData, setBookingData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [isBookingCancelActive, setIsBookingCancelActive] = useState(false);
  const [cancellationError, setCancellationError] = useState("");
  const [serviceAt, setServiceAt] = useState(null);
  const [deposit, setDeposit] = useState(null);
  const [isBookingCancelled, setIsBookingCancelled] = useState(getSessionStorageValue("bookingCancelled") || false);
  const [bookingStatus, setBookingStatus] = useState("");
  useEffect(() => {
    if (bookingStatus.toLowerCase() === "confirmed" && sessionUuid === uuid) {
      setUuid(null);
    }
  }, [bookingStatus, sessionUuid, uuid, setUuid]);
  const [rescheduleCount, setRescheduleCount] = useState(null);
  const [isRescheduled, setIsRescheduled] = useState(false);
  const [isRescheduledExtended, setIsRescheduledExtended] = useState(false);
  const [reschedulingTime, setReschedulingTime] = useState(null);
  const [reschedulingTimeLimit, setReschedulingTimeLimit] = useState(null);
  const [reschedulingMaxLimit, setReschedulingMaxLimit] = useState(null);
  const [isReschedulingTimeOver, setIsReschedulingTimeOver] = useState(false);
  const [isCancelingTimeOver, setIsCancelingTimeOver] = useState(false);
  const [bookingID, setBookingID] = useState(null);
  const [outletData, setOutletData] = useState(null);
  const [isReloadPopupActive, setIsReloadPopupActive] = useState(false);
  const [isStatusChecking, setIsStatusChecking] = useState(false);
  const [reloadPopupStatus, setReloadPopupStatus] = useState("");
  const [pendingAction, setPendingAction] = useState(null);
  const retryCountRef = useRef(0);
  const retryTimeoutRef = useRef(null);
  const isMountedRef = useRef(true);
  const activeRequestRef = useRef(0);
  const isStatusCheckingRef = useRef(false);
  const pendingActionRef = useRef(null);

  // console.log("reschedule >>  reschedulingTime", reschedulingTime);
  

  useEffect(() => {
    clearSessionStorage();
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get("action") === "manage") {
      navigate(location.pathname, { replace: true });
    }
  }, []);

  const clearRetryTimeout = () => {
    if (retryTimeoutRef.current) {
      clearTimeout(retryTimeoutRef.current);
      retryTimeoutRef.current = null;
    }
  };

  const fetchBookingDetail = useCallback(async (
    showLoader = true,
    requestId = activeRequestRef.current,
    options = {}
  ) => {
    const { skipHoldingRetry = false } = options;
    let currentStatus = null;
    try {
      if (showLoader && isMountedRef.current) {
        setMainLoading(true);
      }
      let item = {
        pagination: 0,
      }
      const response = await bookingDetail(uuid, item);
      if (!isMountedRef.current || requestId !== activeRequestRef.current) return null;

      const data = response?.data?.data;
      const booking = data?.bookingData?.[0];
      const latestCustomerData = data?.customerArray;

      setBookingData(data);
      setBookingStatus(booking?.status);
      setBookingID(booking?.booking_id);
      setOutletData(booking?.outlet);
      setServiceAt(booking?.service_at);
      setDeposit(booking?.deposit);
      setRescheduleCount(booking?.reschedule);
      setReschedulingTime(booking?.reschedule_time);
      setReschedulingMaxLimit(
        booking?.reschedule_max_limit != null
          ? Number(booking.reschedule_max_limit)
          : webRescheduleMaxLimit
      );
      setReschedulingTimeLimit(
        booking?.reschedule_time_limit != null
          ? Number(booking.reschedule_time_limit) * 60
          : webRescheduleTimeLimit != null ? webRescheduleTimeLimit * 60 : null
      );
      setRescheduleMaxLimit(
        booking?.reschedule_max_limit != null
          ? Number(booking.reschedule_max_limit)
          : webRescheduleMaxLimit
      );
      setSessionTimeLimitHours(
        booking?.reschedule_time_limit != null
          ? Number(booking.reschedule_time_limit)
          : webRescheduleTimeLimit
      );
      setCustomerData(latestCustomerData);

      currentStatus = booking?.status;
      const isHolding = currentStatus?.toLowerCase() === "holding";
      const isRequestActive =
        isMountedRef.current && requestId === activeRequestRef.current;

      if (isHolding && !skipHoldingRetry) {
        if (retryCountRef.current < 3) {
          retryCountRef.current += 1;
          clearRetryTimeout();
          retryTimeoutRef.current = setTimeout(() => {
            fetchBookingDetail(showLoader, requestId, options);
          }, 2000);
          return null;
        }

        clearRetryTimeout();
        retryCountRef.current = 0;
        if (isRequestActive) {
          setMainLoading(false);
        }
        return null;
      }

      clearRetryTimeout();
      retryCountRef.current = 0;
      if (isRequestActive) {
        setMainLoading(false);
      }

      return {
        status: currentStatus,
        bookingId: booking?.booking_id,
        bookingData: data,
        customerData: latestCustomerData,
        serviceAt: booking?.service_at,
        rescheduleCount: booking?.reschedule,
        reschedulingMaxLimit:
          booking?.reschedule_max_limit != null
            ? Number(booking.reschedule_max_limit)
            : webRescheduleMaxLimit,
      };
    } catch (error) {
      if (!isMountedRef.current || requestId !== activeRequestRef.current) return null;
      logger.error("Error:", error);
      setMainLoading(false);
      return null;
    }
  }, [uuid, setRescheduleMaxLimit, setSessionTimeLimitHours, webRescheduleMaxLimit, webRescheduleTimeLimit]);

  useEffect(() => {
    // Keep mount flag true before starting any request in this cycle.
    isMountedRef.current = true;

    if (!uuid) {
      setMainLoading(false);
      navigate('/');
      return;
    }

    clearRetryTimeout();
    retryCountRef.current = 0;
    activeRequestRef.current += 1;
    const requestId = activeRequestRef.current;
    fetchBookingDetail(true, requestId);

    return () => {
      clearRetryTimeout();
    };
  }, [uuid, fetchBookingDetail, navigate]);

  // Validate booking data exists for valid UUID
  useEffect(() => {
    if (!mainLoading && uuid && !bookingData?.bookingData?.length) {
      navigate('/');
    }
  }, [mainLoading, uuid, bookingData, navigate]);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
      clearRetryTimeout();
      activeRequestRef.current += 1;
    };
  }, []);


  const transformedData = useMemo(() => transformCustomerData(customerData), [customerData]);
  const cartDisplayTotal = useCartDisplayTotal(transformedData, membership);
  const { date: bookingDate, time: bookingTime } = splitDateTime(serviceAt);


  

  useEffect(() => {
  // Booking cancelled
  if (bookingStatus.toLowerCase() === "cancelled" || 
  bookingStatus.toLowerCase() === "no-show" || 
  bookingStatus.toLowerCase() === "completed" ||
  bookingStatus.toLowerCase() === "voided") {
    setIsBookingCancelled(true);
  }else{
    setIsBookingCancelled(false);
  }
  // Reschedule limits
  if (rescheduleCount > 0) {
    setIsRescheduled(true);
  }else{
    setIsRescheduled(false);
  }
  // Rescheduling time checks
  if (
    reschedulingTimeLimit != null &&
    Number(reschedulingTime) < reschedulingTimeLimit &&
    bookingStatus.toLowerCase() === "confirmed"
  ) {
    setIsReschedulingTimeOver(true);
  }else{
    setIsReschedulingTimeOver(false);
  }
  if (reschedulingTime <= 0) {
    setIsCancelingTimeOver(true);
  }else{
    setIsCancelingTimeOver(false);
  }
}, [bookingStatus, rescheduleCount, reschedulingTime, reschedulingTimeLimit]);

  const cancelBookingOpen = () => {
    if (isStatusCheckingRef.current) return;
    setCancellationError("");
    setIsBookingCancelActive(true);
  };
  const cancelBookingClose = () => {
    if (isStatusCheckingRef.current) return;
    setIsBookingCancelActive(false);
  };

  const resetStatusCheckState = () => {
    isStatusCheckingRef.current = false;
    setIsStatusChecking(false);
    setIsReloadPopupActive(false);
    setReloadPopupStatus("");
    pendingActionRef.current = null;
    setPendingAction(null);
  };

  const closeReloadPopup = () => {
    // Invalidate any in-flight status request so a late response is ignored
    activeRequestRef.current += 1;
    resetStatusCheckState();
  };

  const formatBookingStatusLabel = (statusValue) => {
    if (!statusValue) return "";
    const lower = statusValue.toLowerCase();
    if (lower === "no-show") return "No Show";
    if (lower === "check-in (in progress)" || lower === "checked-in") return "Checked-In";
    return statusValue;
  };

  const executeCancelBooking = async () => {
    setCancellationError("");
    const item = {
      uuid,
      panel: "customer",
    };
    try {
      const response = await cancelBooking(item);
      if (!isMountedRef.current) return;

      if (response?.data?.success) {
        setIsBookingCancelled(true);
        sessionStorage.setItem("bookingCancelled", JSON.stringify(true));
        clearRetryTimeout();
        retryCountRef.current = 0;
        activeRequestRef.current += 1;
        const refetchRequestId = activeRequestRef.current;
        await fetchBookingDetail(false, refetchRequestId);
      } else {
        logger.error("Appointment cancel failed:", response);
        setCancellationError(getErrorMessage(response));
      }
    } catch (error) {
      logger.error("Error Appointment cancel:", error);
      if (!isMountedRef.current) return;
      setCancellationError(getErrorMessage(error?.response?.data || error));
    } finally {
      if (isMountedRef.current) {
        setIsBookingCancelActive(false);
        resetStatusCheckState();
      }
    }
  };

  const proceedWithPendingAction = async (latestBooking) => {
    const action = pendingActionRef.current;

    if (action === "cancel") {
      await executeCancelBooking();
      return;
    }

    resetStatusCheckState();

    if (action === "reschedule") {
      executeRescheduleBooking(latestBooking);
    }
  };

  // Shared latest-status gate for Cancel and Reschedule (do not use stale UI status)
  const validateLatestBookingStatus = async (action) => {
    if (isStatusCheckingRef.current) return;

    pendingActionRef.current = action;
    setPendingAction(action);
    if (action !== "cancel") {
      setIsBookingCancelActive(false);
    }
    setIsReloadPopupActive(false);
    setIsStatusChecking(true);
    isStatusCheckingRef.current = true;
    setReloadPopupStatus("");

    clearRetryTimeout();
    retryCountRef.current = 0;
    activeRequestRef.current += 1;
    const requestId = activeRequestRef.current;

    try {
      const latestBooking = await fetchBookingDetail(false, requestId, {
        skipHoldingRetry: true,
      });

      if (!isMountedRef.current || requestId !== activeRequestRef.current) {
        return;
      }

      if (!latestBooking?.status) {
        logger.error("Unable to validate booking status");
        resetStatusCheckState();
        return;
      }

      if (latestBooking.status.toLowerCase() === "confirmed") {
        await proceedWithPendingAction(latestBooking);
        return;
      }

      setIsBookingCancelActive(false);
      setReloadPopupStatus(latestBooking.status);
      setIsReloadPopupActive(true);
      setIsStatusChecking(false);
      isStatusCheckingRef.current = false;
    } catch (error) {
      logger.error("Error validating booking status:", error);
      if (!isMountedRef.current || requestId !== activeRequestRef.current) return;
      resetStatusCheckState();
    }
  };


  const executeRescheduleBooking = (latestBooking) => {
    const maxLimit = latestBooking.reschedulingMaxLimit ?? reschedulingMaxLimit;
    if (
      maxLimit != null &&
      Number(latestBooking.rescheduleCount) >= Number(maxLimit)
    ) {
      setIsRescheduledExtended(true);
      return;
    }

    navigate(`/appointment/${uuid}/select-time`, {
      state: {
        bookingData: latestBooking.bookingData,
        customerData: latestBooking.customerData,
        serviceAt: latestBooking.serviceAt,
      },
    });
  };


  

  const cancelAppointment = async (e) => {
    e.preventDefault();
    await validateLatestBookingStatus("cancel");
  };

  const updateAppointment = async () => {
    setCancellationError("");
    if (isRescheduledExtended || isReschedulingTimeOver) {
      setIsBookingCancelActive(false);
      return;
    }
    await validateLatestBookingStatus("reschedule");
  };

  useEffect(() => {
    const body = document.body;
    body.classList.remove(
      "overlay",
      "half",
      "overlay-index",
      "overflow-hidden"
    );
    if (isBookingCancelActive || isReloadPopupActive || isRescheduledExtended) {
      body.classList.add("overlay", "overflow-hidden", "overlay-index");
    }
  }, [isBookingCancelActive, isReloadPopupActive, isRescheduledExtended]);

  if (mainLoading)
    return (
      <div>
        <LoaderMain />
      </div>
    );

  const footerSmall = makeAnOtherAppointmentOnly || 
                  (isReschedulingTimeOver && !isBookingCancelled) ||
                  bookingStatus.toLowerCase() === "cancelled" || 
                  bookingStatus.toLowerCase() === "no-show" || 
                  bookingStatus.toLowerCase() === "completed" ||
                  bookingStatus.toLowerCase() === "voided" ||
                  bookingStatus.toLowerCase() === "checked-in" ||
                  bookingStatus.toLowerCase() === "check-in (in progress)"



  const statusBadge = bookingStatus.toLowerCase() === "holding" ? badgeHold :
                      bookingStatus.toLowerCase() === "cancelled" ? badgeCancel :
                      bookingStatus.toLowerCase() === "no-show" ? badgeNoShow :
                      bookingStatus.toLowerCase() === "completed" ? badgeCompleted :
                      bookingStatus.toLowerCase() === "voided" ? badgeVoided :
                      bookingStatus.toLowerCase() === "check-in (in progress)" ? BadgeCheckedIn :
                      bookingStatus.toLowerCase() === "checked-in" ? BadgeCheckedIn :
                      bookingStatus.toLowerCase() === "confirmed" && isRescheduled ? BadgeUpdated : 
                      bookingStatus.toLowerCase() === "confirmed" ? BadgeConfirmed : BadgeConfirmed;


  const rescheduleLimitHours =
    reschedulingTimeLimit != null ? reschedulingTimeLimit / 60 : null;
  const rescheduleLimitLabel =
    rescheduleLimitHours != null
      ? `${rescheduleLimitHours} ${rescheduleLimitHours === 1 ? "hour" : "hours"}`
      : "";

  const status = bookingStatus.toLowerCase() === "check-in (in progress)" ? "checked-in" :
                 bookingStatus.toLowerCase() === "confirmed" && isRescheduled ? "updated" :
                 bookingStatus 


  return (
    <div
      className={`${styles.ManageAppointment} space-y ${footerSmall ? "" : styles.withExtendedFooter}`}
    >
      <div className="container-md space-x">
        <BookingStatus
          badge={statusBadge}
          status={status}
        />
      </div>


      <div className={isBookingCancelled ? styles.overlay : ""}>
        <div className="container-md space-x">
        <div className="hr" />
        {/* OUTLET CARD  */}

        <div className={`${styles.outletCardContainer} space-b`}>
        <OutletCard 
          image={outletData?.image}
          name={outletData?.name}
          address={outletData?.address}
          hideContact={true}
          hideSelectBtn={true}
          hideAnnouncements={true}
          hideTiming={true}
        />
        </div>

        <div>
          <TimeDetail selectedDate={bookingDate} selectedTime={bookingTime} bookingID={bookingID} />
        </div>

        <div className="hr mt-0" />


        <ServiceDetails
          members={transformedData}
          membership={membership}
        />

        <div className={styles.hr} />

        <PriceDetails 
        cartTotal={cartDisplayTotal}
        depositMoney={Number(deposit)}
        isDepositPaid={true}
        />

        <div className={`${styles.hr} my-0`} />
        </div>

        {isBookingCancelled ? "" : <div className={styles.termsAndConditionsContainer}><TermsAndConditions /></div>}
      </div>

      {/* Show the cancellation response in preference to the rescheduling notice. */}
      {(cancellationError || isReschedulingTimeOver) && !isBookingCancelled && !makeAnOtherAppointmentOnly &&(
        <Snakbar
          varient="danger"
          type="error"
          text={cancellationError || `Rescheduling is only allowed at least ${rescheduleLimitLabel} before your appointment.`}
          hasButton={true}
          active={Boolean(cancellationError || isReschedulingTimeOver)}
          customClass={footerSmall ? "" : styles.snackbarExtended}
        />
      )} 


      {/* FOOTER  */}
      {footerSmall ? 
        <div data-snackbar-footer="true" className={`${styles.footer} space-x`}>
          <BtnPrimary label="Return to Homepage" handleClick={goToHome} />
        </div> 
        : 
        <div data-snackbar-footer="true" className={`${styles.footer} ${styles.footerExtended} space-x`}>
          <div className={styles.manageBookingFooter}>
            <BtnPrimary
              label={isStatusChecking ? "Processing..." : "Reschedule Appointment"}
              handleClick={updateAppointment}
              disabled={isStatusChecking || isReschedulingTimeOver}
            />
            <BtnSecondary
              varient="dangerText"
              label="Cancel Appointment"
              handleClick={cancelBookingOpen}
              disabled={isCancelingTimeOver || isStatusChecking}
            />
          </div>
        </div>
      }

      <ReloadBookingPopup
        active={isReloadPopupActive && Boolean(reloadPopupStatus)}
        handleClick={closeReloadPopup}
        status={formatBookingStatusLabel(reloadPopupStatus)}
        action={pendingAction === "cancel" ? "cancel" : "reschedule"}
        onReload={closeReloadPopup}
      />

      <BookingCancelConfirmationPopup
        active={isBookingCancelActive}
        handleClick={cancelBookingClose}
        cancelAppointment={cancelAppointment}
        rescheduleBooking={updateAppointment}
        bookingID={bookingID}
        cancelAppointmentDisabled={isCancelingTimeOver || isStatusChecking}
        rescheduleDisabled={isStatusChecking}
        isProcessing={isStatusChecking && pendingAction === "cancel"}
      />

      <ReschedulingExtendedPopup
        active={isRescheduledExtended}
        handleClick={() => setIsRescheduledExtended(false)}
        reschedulingMaxLimit={reschedulingMaxLimit}
      />

    </div>
  );
};

export default ManageAppointment;
